import { render, staticRenderFns } from "./edit-manage-model-dialog.vue?vue&type=template&id=5aa31de4&scoped=true&"
import script from "./edit-manage-model-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-manage-model-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-manage-model-dialog.vue?vue&type=style&index=0&id=5aa31de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa31de4",
  null
  
)

export default component.exports